import React from 'react';
import {Provider} from "react-redux";
import configure from "../../store/configure";
import AnnounceDetailContainer from "./container/AnnounceDetailContainer";
import { useParams} from "react-router-dom";
import Layout from "../../component/layout/Layout";

const AnnounceDetailPage = () => {
    const params = useParams();

    return (
        <Provider store={configure}>
            <Layout>
                <AnnounceDetailContainer
                    params={params}
                />
            </Layout>
        </Provider>
    );
};

export default AnnounceDetailPage;
